<script>

    import LoopItemEditor from "./../LoopItemEditor";

    export default {

		extends: LoopItemEditor,

        data()
        {
        	return {
				forcedLoopIndex: null,
            };
        },

        created()
		{
			// Init managing loop index.
			this.manageLoopIndex();

			this.owlElement.on('changed.owl.carousel', this.manageLoopIndex);
		},

        beforeDestroy()
		{
			// Stop listen for changed slides.
		    this.owlElement.unbind('changed.owl.carousel', this.manageLoopIndex);
		},

        methods: {

			manageLoopIndex()
            {
            	// @ugly Abort due to element is not present anymore?
            	if(this.element.closest('body').length == 0) {

            		console.warn('Delete slide item from itself! uid: ' + this._uid);

            		for(let child of [...this.$children])
            			child.$destroy();

					this.$destroy();

					return;
				}

            	// Cloned?
				if (this.element.parent().is('.owl-item.cloned'))
					this.forcedLoopIndex = this.getLoopIndexClonedSlide();

				// Non cloned?
				else
					this.forcedLoopIndex = this.getLoopIndexSlide();
			},

			getLoopIndexSlide()
			{
				// Get slider element.
				let thisOwlSlide = this.element.closest('.owl-item').get(0);

				// Return index of this element.
				for(let index in this.owlInstance._items)
				{
					if(this.owlInstance._items[index].get(0) == thisOwlSlide) {
						return parseInt(index);
					}
				}

				//
				return null;
			},

			getLoopIndexClonedSlide()
			{
                // Get slide index.
                let slideIndex = this.loopEditorComponent.owlSliderElement.find('.owl-item').toArray().indexOf(this.element.parent().get(0));

                // Loop items.
                for(let i = 0; i < this.owlInstance._items.length; i++)
                {
                    // Loop clones of this item.
                    for(let index of this.owlInstance.clones(i))
                    {
                        // Clone found?
                        if(index == slideIndex)
                            return i;
                    }
                }

                //
                return null;
			},

        },

		computed: {

			owlElement()
            {
            	return this.loopEditorComponent.owlSliderElement;
            },

			owlInstance()
            {
            	return this.owlElement.data('owl.carousel');
            },

			loopIndex()
			{
				return this.forcedLoopIndex;
			},

            // @override
			panelComponent()
			{
				// Use default?
				if(!this.editableData.itemPanel)
					return window.Vue.options.components['common-canvas-editor-canvas-document-editors-loop-owlCarousel-loopitempanel'];

				// Determine custom component.
				let componentTag = 'common-canvas-blocks-' + this.canvasBlock.block.replace('.', '-').toLowerCase() + '-admin-' + this.editableData.itemPanel.toLowerCase();
				let component = window.Vue.options.components[componentTag]

				if(!component)
					throw {
						message: 'Loop item panel not found!',
						componentTag,
						component,
					};

				return component;
			},

		},

	}

</script>